export enum TransferRecipientTypeEnum {
  Individual = 'Individual',
  Business = 'Business',
}
